/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-07-07 10:04:26
 * @LastEditors: Please set LastEditors
 */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Divider, Spin } from 'sup-ui';
import CommonModal from 'root/components/CommonModal';
import alonePic from 'root/assets/images/standalonesmall@2x.png';
import colonyPic from 'root/assets/images/illustrator_colony.png';

import AddEnv from './AddEnv';

import { getEnvListApi, deleteEnvApi } from 'root/services/multipleInstances';
import { envManage } from 'root/pages/EnvManage/store/actions';
import { common } from 'root/store/actions';
import { useDispatch } from 'react-redux';
import packImg from 'root/assets/images/illustrator_empty2.png';

import messages from '../messages';
import styles from '../index.less';

const { confirm } = CommonModal;
let timer: any;

const List = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [list, setList] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getEnvList();
    return () => {
      clearTimeout(timer);
      timer = null;
    };
  }, []);

  // 获取环境实例列表
  const getEnvList = () => {
    getEnvListApi()
      .then((res) => {
        const {
          data: { envInfos, enableMultiInstance, defaultMultiHomePage },
        } = res;

        setList(envInfos);
        sessionStorage.setItem('enableMultiInstance', enableMultiInstance ? '1' : ''); // 用于控制详情页是否显示返回按钮
        if (!envInfos || !envInfos.length) {
          // 没有运行环境并且不支持多实例 ,跳转到添加运行环境页
          if (!enableMultiInstance) {
            dispatch(common.updateEnv({ hasEnv: false }));
            dispatch(envManage.changeEnvStatus({ runtimeEnvId: '' }));
            sessionStorage.removeItem('runtimeEnvId');
            sessionStorage.removeItem('envStatus');
            window.hashHistory.push('/inductive');
            return;
          }
        } else {
          // 有运行环境不支持多实例或支持多实例但不默认多实例主页,首次或者刷新页面进入详情页
          if ((window.hashHistory.action === 'POP' && !defaultMultiHomePage) || !enableMultiInstance) {
            handleCheckDetail(envInfos[0]);
            return;
          }
        }

        clearTimeout(timer);
        timer = setTimeout(() => {
          getEnvList();
        }, 10 * 1000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 进入实例详情 设置runtimeEnvId用于请求头
  const handleCheckDetail = (data: any) => {
    const { runtimeEnvId, deployMode, supOSInstalled, initStatus } = data;

    if (!initStatus) return;

    // 保存用户点击的环境信息,页面刷新不丢失
    const envStatus = {
      runtimeEnvId, // 运行环境id
      isSuposInstalled: supOSInstalled,
      cluster: deployMode,
      hasOperatingEnv: true,
      singleNodeId: '',
      sysStatus: '',
    };
    dispatch(envManage.changeEnvStatus({ acitveKey: '1' }));
    dispatch(envManage.changeEnvStatus(envStatus));
    sessionStorage.setItem('envStatus', JSON.stringify(envStatus));

    // 跳转实例详情,更新环境id
    window.hashHistory.push('/instances');
    sessionStorage.setItem('runtimeEnvId', runtimeEnvId);
  };

  // 删除运行环境
  const handleDeleteNode = (val: any) => {
    const { runtimeEnvId, nodesStatus, initStatus } = val;
    // 没有完成初始化过程,禁止删除环境
    if (!initStatus) return;

    // 只有主机状态为空的时候可以删除;
    if (nodesStatus === '0/0') {
      confirm({
        title: intl.formatMessage(messages.confirmDelete),
        onOk: () => {
          deleteEnvApi({ runtimeEnvId }).then(() => {
            getEnvList();
          });
        },
      });
      return;
    }
    confirm({
      title: intl.formatMessage(messages.deletewarning),
      cancelButtonProps: { style: { display: 'none' } },
      okButtonProps: { style: { marginLeft: '180px', width: '108px', height: '32px' } },
    });
  };

  return (
    <Spin spinning={loading}>
      <div className={styles.hostList}>
        <AddEnv getEnvList={getEnvList} />
        <div className={styles.host_list}>
          <div className={styles.content}>
            {list.length ? (
              list.map((item: any) => (
                <div key={item.id} className={styles.hostItem}>
                  <div className={styles.deployment} style={item.deployMode === 1 ? { background: '#1bb934' } : {}}>
                    {intl.formatMessage(item.deployMode === 1 ? messages.colonyText : messages.aloneText)}
                  </div>
                  <div className={styles.hostItem_detail}>
                    <div className={styles.imgBox}>
                      <img className={styles.img} alt="" src={item.deployMode === 1 ? colonyPic : alonePic} />
                    </div>
                    <div className={styles.info}>
                      <h4 className={styles.title}>{item.envName || intl.formatMessage(messages.defaultEnvName)}</h4>
                      <div className={styles.hostInfo}>
                        <span>{intl.formatMessage(messages.hostStatus)}</span>
                        <span>{item.nodesStatus}</span>
                      </div>
                      <div className={styles.hostInfo}>
                        <span>{intl.formatMessage(messages.serverStatus)}</span>
                        <span>{item.servicesStatus}</span>
                      </div>
                    </div>
                  </div>
                  <div className={styles.oprerate}>
                    <span
                      onClick={() => handleCheckDetail(item)}
                      className={!item.initStatus ? styles.disableDelete : ''}
                    >
                      {intl.formatMessage(messages.viewDetail)}
                    </span>
                    <Divider type="vertical" />
                    <span
                      onClick={() => handleDeleteNode(item)}
                      className={item.inUse || !item.initStatus ? styles.disableDelete : styles.delete}
                    >
                      {intl.formatMessage(messages.delete)}
                    </span>
                  </div>
                  {!item.initStatus && (
                    <p className={styles.init}>
                      {intl.formatMessage(messages.init)} <Spin size="small" style={{ marginLeft: 5 }} />
                    </p>
                  )}
                </div>
              ))
            ) : (
              <div className={styles.empty}>
                <img src={packImg} />
                <div>{intl.formatMessage(messages.welcomeTip)}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default List;
